<p-chart type="bar" height="325" [data]="data" [options]="options"></p-chart>